import { Moment } from 'moment';
import moment from 'moment';

function getTimesArray(max: number) {
  let times = [];
  for (let i = 0; i < max; i++) {
    times.push(i);
  }
  return times;
}

function dateBoundariesFromNow() {
  const now = moment();
  const min = now.clone().add(12, 'hours');
  const max = now.clone().add(48, 'hours');
  return [min, max];
}

export function isDateDisabled(date: Moment) {
  const [min, max] = dateBoundariesFromNow();
  return date.isBefore(min) || date.isAfter(max);
}

export const getDisabledHours = (date: Moment | undefined) =>
  date ? getTimesArray(24).filter((hour) => isHourDisabled(hour, date)) : [];

const isHourDisabled = (hour: number, date: Moment) => {
  const oldDate = moment(date);
  const datePlusHour = oldDate.startOf('day').add(hour, 'hour');
  return isDateDisabled(datePlusHour);
};

export const getDisabledMinutes = (date: Moment | undefined, hour: number) =>
  date ? getTimesArray(60).filter((minute) => isMinuteDisabled(date, hour, minute)) : [];

const isMinuteDisabled = (date: Moment | undefined, hour: number, minute: number) => {
  const oldDate = moment(date);
  const datePlusMinute = oldDate.startOf('day').add(hour, 'hour').add(minute, 'minutes');
  return isDateDisabled(datePlusMinute);
};

export function correctDate(date: Moment) {
  let newDate = date.clone();
  const [min, max] = dateBoundariesFromNow();
  if (date.isAfter(max)) newDate = min.clone();
  if (date.isBefore(min)) newDate = max.clone();
  // console.log(
  //   `CORRECTING: ${date.toString()} =====> \nMIN: ${min.toString()} \nMAX: ${max.toString()} \n ${date.toString()} =>>> ${newDate.toString()}`
  // );
  return newDate;
}
